import { render, staticRenderFns } from "./GlossesByProfessionalReport.vue?vue&type=template&id=4a2b72d7"
import script from "./GlossesByProfessionalReport.vue?vue&type=script&lang=js"
export * from "./GlossesByProfessionalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports